import { Injectable } from '@angular/core';
import { encode as base64Encode, decode as base64Decode } from 'base-64';
import { encode as utf8Encode, decode as utf8Decode } from 'utf8';

@Injectable({ providedIn: 'root' })
export class AuthStorageService {
  private readonly KEY = 'login_data';

  getUser(): any {
    const raw = localStorage.getItem(this.KEY);
    if (!raw) return null;
    try {
      return JSON.parse(utf8Decode(base64Decode(raw)));
    } catch {
      return null;
    }
  }

  setUser(user: any): void {
    localStorage.setItem(
      this.KEY,
      base64Encode(utf8Encode(JSON.stringify(user)))
    );
  }

  clearUser(): void {
    localStorage.removeItem(this.KEY);
  }

  hasUser(): boolean {
    return localStorage.getItem(this.KEY) !== null;
  }
}
